export { default } from 'components/ContentPage/ContentPage';
